export default {
  'pages.userPaymentReview.title': 'User Payment Review (Migrated)',
  'pages.userPaymentReview.actions.search': 'Search',
  'pages.userPaymentReview.actions.clear': 'Clear',
  'pages.userPaymentReview.actions.review': 'Review Payment',
  'pages.userPaymentReview.filters.paymentDate': 'Payment Date',
  'pages.userPaymentReview.filters.reviewedDate': 'Reviewed Date',
  'pages.userPaymentReview.filters.search': 'Search',
  'pages.userPaymentReview.filters.searchPlaceholder': 'User ID, phone or name',
  'pages.userPaymentReview.filters.reviewedBy': 'Reviewed By',
  'pages.userPaymentReview.filters.status': 'Review Status',
  'pages.userPaymentReview.filters.direction': 'Direction',
  'pages.userPaymentReview.filters.type': 'Transaction Type',
  'pages.userPaymentReview.options.all': 'All',
  'pages.userPaymentReview.options.reviewed': 'Reviewed',
  'pages.userPaymentReview.options.notReviewed': 'Not reviewed',
  'pages.userPaymentReview.options.payin': 'Pay-in',
  'pages.userPaymentReview.options.payout': 'Pay-out',
  'pages.userPaymentReview.options.installment': 'Installment',
  'pages.userPaymentReview.options.penalty': 'Penalty',
  'pages.userPaymentReview.columns.totalAmount': 'Total Amount',
  'pages.userPaymentReview.columns.paidAmount': 'Paid Amount',
  'pages.userPaymentReview.columns.transactionFees': 'Transaction Fees',
  'pages.userPaymentReview.columns.settled': 'Settled',
  'pages.userPaymentReview.columns.dueDate': 'Due Date',
  'pages.userPaymentReview.columns.paidDate': 'Paid Date',
  'pages.userPaymentReview.columns.bundle': 'Bundle',
  'pages.userPaymentReview.columns.transactionId': 'Transaction Id',
  'pages.userPaymentReview.columns.transactionSource': 'Transaction Source',
  'pages.userPaymentReview.columns.transactionType': 'Transaction Type',
  'pages.userPaymentReview.columns.transactionDirection':
    'Transaction Direction',
  'pages.userPaymentReview.columns.notes': 'Notes',
  'pages.userPaymentReview.columns.review': 'Review',
  'pages.userPaymentReview.noFees': 'No Fees',
  'pages.userPaymentReview.yes': 'Yes',
  'pages.userPaymentReview.no': 'No',
  'pages.userPaymentReview.reviewedBy': 'Reviewed by',
  'pages.userPaymentReview.at': 'at',
  'pages.userPaymentReview.modal.title': 'Review Payment',
  'pages.userPaymentReview.modal.submit': 'Review',
  'pages.userPaymentReview.modal.cancel': 'Cancel',
  'pages.userPaymentReview.modal.reason': 'Review Reason',
  'pages.userPaymentReview.modal.notes': 'Review Notes',
  'pages.userPaymentReview.modal.other': 'Other',
  'pages.userPaymentReview.messages.lookupsFailed':
    'Failed to load payment review lookups',
  'pages.userPaymentReview.messages.listFailed':
    'Failed to fetch payment reviews',
  'pages.userPaymentReview.messages.reviewAdded':
    'Payment review added successfully',
  'pages.userPaymentReview.messages.reviewFailed': 'Payment review failed',
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.login.or': 'OR',
  'pages.login.keycloak': 'Login with Keycloak',
  'pages.login.keycloak.description':
    'Secure login through enterprise identity provider',
  'pages.login.keycloak.mock': 'Login with Mock Keycloak',
  'pages.login.keycloak.mock.description':
    'Use mock identity provider for development testing',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.payout.title': 'Payout Management',
  'pages.payout.subtitle':
    'Manage user payouts, batches, and freezing operations',
  'pages.payout.search.placeholder': 'Enter search term',
  'pages.payout.search.types.uuid': 'UUID',
  'pages.payout.search.types.nationalId': 'National ID',
  'pages.payout.search.types.phoneNumber': 'Phone Number',
  'pages.payout.filters.title': 'Advanced Filters',
  'pages.payout.filters.payoutMonth': 'Payout Month',
  'pages.payout.filters.userTypes': 'User Type',
  'pages.payout.filters.payoutAmount': 'Payout Amount',
  'pages.payout.filters.payoutType': 'Payout Type',
  'pages.payout.filters.urgentCases': 'Urgent Cases',
  'pages.payout.filters.userTypes.individual': 'Individual',
  'pages.payout.filters.userTypes.selfPay': 'Self-pay',
  'pages.payout.filters.userTypes.salaryDeduction': 'Salary deduction',
  'pages.payout.filters.payoutAmount.lessThan500': '≤ 500 EGP',
  'pages.payout.filters.payoutAmount.moreThan500': '> 500 EGP',
  'pages.payout.filters.payoutType.normal': 'Normal payout',
  'pages.payout.filters.payoutType.early': 'Early payout',
  'pages.payout.filters.urgentCases.yes': 'Yes',
  'pages.payout.filters.urgentCases.no': 'No',
  'pages.payout.actions.bulkAddToBatch': 'Bulk Add to Batch',
  'pages.payout.actions.bulkFreeze': 'Bulk Freeze Users',
  'pages.payout.actions.export': 'Export Data',
  'pages.payout.table.uuid': 'UUID',
  'pages.payout.table.fullName': 'Full Name',
  'pages.payout.table.nationalId': 'National ID',
  'pages.payout.table.phoneNumber': 'Phone Number',
  'pages.payout.table.paymentMethod': 'Payment Method',
  'pages.payout.table.paymentData': 'Payment Data',
  'pages.payout.table.payoutAmount': 'Payout Amount',
  'pages.payout.table.dueDate': 'Due Date',
  'pages.payout.table.cashoutDueDate': 'Cashout Due Date',
  'pages.payout.table.status': 'Status',
  'pages.payout.table.newUser': 'New User',
  'pages.payout.table.updatedAt': 'Updated At',
  'pages.payout.table.actions': 'Actions',
  'pages.payout.table.actions.addToBatch': 'Add to Batch',
  'pages.payout.table.actions.freeze': 'Freeze',
  'pages.payout.modals.addToBatch.title': 'Add User to Batch',
  'pages.payout.modals.addToBatch.user': 'User',
  'pages.payout.modals.addToBatch.nationalId': 'National ID',
  'pages.payout.modals.addToBatch.amount': 'Amount',
  'pages.payout.modals.addToBatch.selectBatch': 'Select Batch',
  'pages.payout.modals.freezeUser.title': 'Freeze User Payout',
  'pages.payout.modals.freezeUser.freezeReason': 'Freeze Reason',
  'pages.payout.modals.freezeUser.notes': 'Additional Notes (Optional)',
  'pages.payout.modals.bulkAddToBatch.title': 'Bulk Add to Batch',
  'pages.payout.modals.bulkAddToBatch.nationalIds':
    'National IDs (one per line)',
  'pages.payout.modals.bulkFreeze.title': 'Bulk Freeze Users',
  'pages.payout.modals.validation.valid': 'valid',
  'pages.payout.modals.validation.invalid': 'invalid',
  'pages.payout.modals.validation.duplicates': 'duplicates',
  'pages.payout.modals.results.success': 'Successfully Added',
  'pages.payout.modals.results.failed': 'Failed to Add',
  'pages.payout.modals.results.duplicates': 'Duplicates Skipped',
  'pages.payout.modals.results.frozen': 'Successfully Frozen',
  'pages.payout.modals.results.freezeFailed': 'Failed to Freeze',
  'pages.payout.messages.uuidCopied': 'UUID copied to clipboard',
  'pages.payout.messages.uuidCopyFailed': 'Failed to copy UUID',
  'pages.payout.messages.searchFailed': 'Search failed',
  'pages.payout.messages.fetchFailed': 'Failed to fetch payout data',
  'pages.payout.messages.batchAdded': 'User added to batch successfully',
  'pages.payout.messages.batchAddFailed': 'Failed to add user to batch',
  'pages.payout.messages.userFrozen': 'User frozen successfully',
  'pages.payout.messages.userFreezeFailed': 'Failed to freeze user',
  'pages.payout.messages.bulkBatchAdded': 'users added to batch successfully',
  'pages.payout.messages.bulkBatchAddFailed': 'users failed to add to batch',
  'pages.payout.messages.bulkUserFrozen': 'users frozen successfully',
  'pages.payout.messages.bulkUserFreezeFailed': 'users failed to freeze',
  'pages.payout.messages.duplicatesSkipped': 'duplicate users skipped',
  'pages.payout.messages.exportInfo':
    'Export functionality will be implemented',
  'pages.leaveBundleRequests.title': 'Leave Bundle Requests (Migrated)',
  'pages.leaveBundleRequests.common.yes': 'Yes',
  'pages.leaveBundleRequests.common.no': 'No',
  'pages.leaveBundleRequests.common.close': 'Close',
  'pages.leaveBundleRequests.columns.actions': 'Actions',
  'pages.leaveBundleRequests.actions.approve': 'Approve',
  'pages.leaveBundleRequests.actions.cancel': 'Cancel',
  'pages.leaveBundleRequests.filters.smartSaving': 'Smart Saving',
  'pages.leaveBundleRequests.filters.hasNotPayin': 'Has Not Payin',
  'pages.leaveBundleRequests.filters.hasNotPayout': 'Has Not Payout',
  'pages.leaveBundleRequests.filters.payoutMethods': 'Payment Methods',
  'pages.leaveBundleRequests.disapprove.title': 'Cancel Leave Request',
  'pages.leaveBundleRequests.disapprove.note': 'Note',
  'pages.leaveBundleRequests.disapprove.confirm': 'Cancel Request',
  'pages.leaveBundleRequests.remove.title': 'Approve Leave Request',
  'pages.leaveBundleRequests.remove.reason': 'Leave Reason',
  'pages.leaveBundleRequests.remove.note': 'Note',
  'pages.leaveBundleRequests.remove.confirm': 'Approve',
  'pages.leaveBundleRequests.remove.inProgressConfirm':
    'Contract in progress. Continue?',
  'pages.leaveBundleRequests.remove.signedConfirm':
    'Contract signed. Continue?',
  'pages.leaveBundleRequests.bulkApprove.toolbar': 'Bulk Approve',
  'pages.leaveBundleRequests.bulkApprove.title': 'Bulk Approve Leave Requests',
  'pages.leaveBundleRequests.bulkApprove.requestIds': 'Request IDs',
  'pages.leaveBundleRequests.bulkApprove.requestIdsPlaceholder':
    'Enter one request ID per line',
  'pages.leaveBundleRequests.bulkApprove.category': 'Category',
  'pages.leaveBundleRequests.bulkApprove.reason': 'Leave Reason',
  'pages.leaveBundleRequests.bulkApprove.confirm': 'Approve',
  'pages.leaveBundleRequests.messages.loadFailed':
    'Failed to fetch leave bundle requests',
  'pages.leaveBundleRequests.messages.loadReasonsFailed':
    'Could not load leave reasons',
  'pages.leaveBundleRequests.messages.cancelSuccess': 'Request cancelled',
  'pages.leaveBundleRequests.messages.cancelFailed': 'Failed to cancel request',
  'pages.leaveBundleRequests.messages.removeSuccess':
    'User removed from bundle',
  'pages.leaveBundleRequests.messages.removeFailed':
    'Failed to remove user from bundle',
  'pages.leaveBundleRequests.messages.bulkApproveSuccess':
    'Bulk approve completed',
  'pages.leaveBundleRequests.messages.bulkApproveFailed': 'Bulk approve failed',
  'pages.deadLetterMessages.title': 'Dead Letter Messages',
  'pages.deadLetterMessages.detailsTitle': 'Dead Letter Message Details',
  'pages.deadLetterMessages.filters.broker': 'Broker',
  'pages.deadLetterMessages.filters.mainQueue': 'Main Queue',
  'pages.deadLetterMessages.filters.status': 'Status',
  'pages.deadLetterMessages.filters.date': 'Date',
  'pages.deadLetterMessages.stats.byStatus': 'Messages by Status',
  'pages.deadLetterMessages.stats.pendingByBroker': 'Pending by Broker',
  'pages.deadLetterMessages.stats.topQueues': 'Top Queues',
  'pages.deadLetterMessages.table.id': 'ID',
  'pages.deadLetterMessages.table.messageId': 'Message ID',
  'pages.deadLetterMessages.table.deadLetterQueue': 'Dead Letter Queue',
  'pages.deadLetterMessages.table.receiveCount': 'Receive Count',
  'pages.deadLetterMessages.table.errorReason': 'Error Reason',
  'pages.deadLetterMessages.table.enqueuedAt': 'Enqueued At',
  'pages.deadLetterMessages.table.actions': 'Actions',
  'pages.deadLetterMessages.actions.view': 'View',
  'pages.deadLetterMessages.actions.editPayload': 'Edit Payload',
  'pages.deadLetterMessages.actions.redrive': 'Redrive',
  'pages.deadLetterMessages.actions.bulkRedrive': 'Bulk Redrive',
  'pages.deadLetterMessages.actions.discard': 'Discard',
  'pages.deadLetterMessages.actions.refresh': 'Refresh',
  'pages.deadLetterMessages.modals.editPayload.title': 'Edit Message Payload',
  'pages.deadLetterMessages.modals.bulkRedrive.title':
    'Bulk Redrive Dead Letter Messages',
  'pages.deadLetterMessages.modals.discard.title': 'Discard Message',
  'pages.deadLetterMessages.modals.jobProgress.title': 'Redrive Job Progress',
  'pages.deadLetterMessages.messages.fetchFailed':
    'Failed to fetch dead letter messages',
  'pages.deadLetterMessages.messages.redriveStarted': 'Redrive job started',
  'pages.deadLetterMessages.messages.payloadUpdated':
    'Payload updated successfully',
  'pages.deadLetterMessages.messages.discarded':
    'Message discarded successfully',
  'pages.quotaManagement.dashboard.title': 'Dashboard',
  'pages.quotaManagement.dashboard.slotBadge':
    '1 slot = 1 bundle = EGP {amount}',
  'pages.quotaManagement.dashboard.empty': 'No dashboard data to display yet.',
  'pages.quotaManagement.dashboard.loadError': 'Failed to load dashboard data.',
  'pages.quotaManagement.dashboard.kpi.total': 'Total slots',
  'pages.quotaManagement.dashboard.kpi.assigned': 'Assigned to divisions',
  'pages.quotaManagement.dashboard.kpi.unassigned': 'Unassigned',
  'pages.quotaManagement.dashboard.kpi.filled': 'Filled',
  'pages.quotaManagement.dashboard.kpi.slots': 'slots',
  'pages.quotaManagement.dashboard.kpi.percentOfTotal':
    '{percent}% of the total',
  'pages.quotaManagement.dashboard.kpi.unassignedHint': 'not assigned onward',
  'pages.quotaManagement.dashboard.kpi.payoutValue': '{value} payout value',
  'pages.quotaManagement.dashboard.kpi.filledSubtext':
    '{percent}% of the total · {value}',
  'pages.quotaManagement.dashboard.chart.title': 'Target vs filled by slot',
  'pages.quotaManagement.dashboard.chart.subtitle': '{name} · {duration}-month',
  'pages.quotaManagement.dashboard.chart.durationLabel': 'Duration',
  'pages.quotaManagement.dashboard.chart.durationOption': '{duration} months',
  'pages.quotaManagement.dashboard.chart.empty':
    'No target vs filled data to display.',
  'pages.quotaManagement.dashboard.chart.legendTarget': 'Target',
  'pages.quotaManagement.dashboard.chart.legendFilled': 'Filled',
  'pages.quotaManagement.dashboard.chart.legendOpen': 'Opened',
  'pages.quotaManagement.dashboard.chart.note':
    'Bar height = target · slot targets come from supply & demand forecasting',
  'pages.quotaManagement.dashboard.chart.tooltip':
    'Slot {slot}: {filled} filled · {open} open · {target} target ({percent}%)',
  'pages.quotaManagement.dashboard.table.title': 'Quota by {type}',
  'pages.quotaManagement.dashboard.table.allocate': 'Allocate & move',
  'pages.quotaManagement.dashboard.table.totalSlots': 'Total slots',
  'pages.quotaManagement.dashboard.table.filled': 'Filled',
  'pages.quotaManagement.dashboard.table.open': 'Open',
  'pages.quotaManagement.dashboard.table.fillRate': 'Fill rate',
  'pages.quotaManagement.dashboard.table.empty': 'No quota to display.',
  'pages.quotaManagement.myQuota.title': 'Dashboard',
  'pages.quotaManagement.myQuota.infoTag': '1 slot = 1 bundle = EGP {amount}',
  'pages.quotaManagement.myQuota.filter.month': 'Month',
  'pages.quotaManagement.myQuota.summary.totalSlots': 'Total slots',
  'pages.quotaManagement.myQuota.summary.slotsValue': '{count} slots',
  'pages.quotaManagement.myQuota.summary.payoutCapacity':
    '{amount} payout capacity',
  'pages.quotaManagement.myQuota.summary.filled': 'Filled',
  'pages.quotaManagement.myQuota.summary.open': 'Open',
  'pages.quotaManagement.myQuota.summary.acrossPositions':
    'across {count} slot positions',
  'pages.quotaManagement.myQuota.summary.fillRate': 'Fill rate',
  'pages.quotaManagement.myQuota.summary.fillRateHint':
    'of the slots assigned to me',
  'pages.quotaManagement.myQuota.table.title': 'My quota by duration and slot',
  'pages.quotaManagement.myQuota.table.readOnly': 'Read only',
  'pages.quotaManagement.myQuota.table.duration': 'Duration',
  'pages.quotaManagement.myQuota.table.slot': 'Slot',
  'pages.quotaManagement.myQuota.table.totalSlots': 'Total slots',
  'pages.quotaManagement.myQuota.table.filled': 'Filled',
  'pages.quotaManagement.myQuota.table.open': 'Open',
  'pages.quotaManagement.myQuota.table.fill': 'Fill',
  'pages.quotaManagement.myQuota.table.fillRate': 'Fill rate',
  'pages.quotaManagement.myQuota.table.payoutCapacityLeft':
    'Payout capacity left',
  'pages.quotaManagement.myQuota.duration.months': '{count} months',
  'pages.quotaManagement.myQuota.empty': 'No quota data to display yet.',
  'pages.quotaManagement.myQuota.fetchFailed': 'Failed to load quota data.',
  'pages.quotaManagement.hierarchy.title': 'Hierarchy',
  'pages.quotaManagement.hierarchy.description':
    'Everything below {organization}',
  'pages.quotaManagement.hierarchy.empty': 'No hierarchy data to display yet.',
  'pages.quotaManagement.hierarchy.loadError': 'Failed to load hierarchy data.',
  'pages.quotaManagement.hierarchy.noQuota': 'no quota',
  'pages.quotaManagement.hierarchy.nodeMeta': '{type} · {owner}',
  'pages.quotaManagement.hierarchy.columns.node': 'Node',
  'pages.quotaManagement.hierarchy.columns.totalSlots': 'Total slots',
  'pages.quotaManagement.hierarchy.columns.filled': 'Filled',
  'pages.quotaManagement.hierarchy.columns.opened': 'Opened',
  'pages.quotaManagement.hierarchy.columns.fillRate': 'Fill rate',
  'pages.quotaManagement.hierarchy.columns.actions': 'Actions',
  'pages.quotaManagement.hierarchy.actions.add': 'Add',
  'pages.quotaManagement.hierarchy.actions.edit': 'Edit',
  'pages.quotaManagement.hierarchy.actions.delete': 'Delete',
  'pages.quotaManagement.hierarchy.addUnder': 'Add under {parent}',
  'pages.quotaManagement.hierarchy.addNode.title': 'Add under {parent}',
  'pages.quotaManagement.hierarchy.addNode.submit': 'Add node',
  'pages.quotaManagement.hierarchy.addNode.cancel': 'Cancel',
  'pages.quotaManagement.hierarchy.addNode.parent': 'Parent',
  'pages.quotaManagement.hierarchy.addNode.type': 'Type',
  'pages.quotaManagement.hierarchy.addNode.owner': 'Owner',
  'pages.quotaManagement.hierarchy.addNode.name': 'Name',
  'pages.quotaManagement.hierarchy.addNode.ownerPlaceholder': 'No owner yet.',
  'pages.quotaManagement.hierarchy.addNode.ownerHelp':
    'Assigning an owner is what gives that person access.',
  'pages.quotaManagement.hierarchy.addNode.namePlaceholder':
    'e.g. Alexandria Retail',
  'pages.quotaManagement.hierarchy.addNode.nameHelp':
    'New nodes start with no quota until someone above assigns to them.',
  'pages.quotaManagement.hierarchy.addNode.typeRequired':
    'Please select a type.',
  'pages.quotaManagement.hierarchy.addNode.nameRequired':
    'Please enter a name.',
  'pages.quotaManagement.hierarchy.addNode.success': 'Node added successfully.',
  'pages.quotaManagement.hierarchy.addNode.error': 'Failed to add node.',
  'pages.quotaManagement.hierarchy.editNode.title': 'Edit node',
  'pages.quotaManagement.hierarchy.editNode.submit': 'Save',
  'pages.quotaManagement.hierarchy.editNode.success':
    'Node updated successfully.',
  'pages.quotaManagement.hierarchy.editNode.error': 'Failed to update node.',
  'pages.quotaManagement.hierarchy.deleteNode.title': 'Delete node',
  'pages.quotaManagement.hierarchy.deleteNode.confirm':
    'Delete {name}? This cannot be undone.',
  'pages.quotaManagement.hierarchy.deleteNode.success':
    'Node deleted successfully.',
  'pages.quotaManagement.hierarchy.deleteNode.error': 'Failed to delete node.',
  'pages.quotaManagement.hierarchy.types.organization': 'Organization',
  'pages.quotaManagement.hierarchy.types.division': 'Channel',
  'pages.quotaManagement.hierarchy.types.channel': 'Sub-channel',
  'pages.quotaManagement.hierarchy.types.team': 'Team leader',
  'pages.quotaManagement.hierarchy.types.agent': 'Sales Agent',
  'pages.quotaManagement.slotAllocation.title': 'Allocate and move quota',
  'pages.quotaManagement.slotAllocation.description':
    'Allocate quota one level down within your hierarchy scope.',
  'pages.quotaManagement.slotAllocation.empty':
    'No slot allocation data to display yet.',
  'pages.quotaManagement.slotAllocation.table.noChildren':
    'This node has no children — there is nothing to allocate here.',
  'pages.quotaManagement.slotAllocation.table.notAllocatedYet':
    'Nothing has been allocated to this node yet this month, so there is no grid to edit.',
  'pages.quotaManagement.slotAllocation.loadError':
    'Failed to load slot allocation data.',
  'pages.quotaManagement.slotAllocation.slotBadge':
    '1 slot = 1 bundle = EGP {amount}',
  'pages.quotaManagement.slotAllocation.duration.label': 'Duration',
  'pages.quotaManagement.slotAllocation.duration.option': '{duration} months',
  'pages.quotaManagement.slotAllocation.kpi.total': 'Total slots',
  'pages.quotaManagement.slotAllocation.kpi.assigned': 'Assigned',
  'pages.quotaManagement.slotAllocation.kpi.unassigned': 'Unassigned',
  'pages.quotaManagement.slotAllocation.kpi.unassignedAll':
    'Unassigned, all durations',
  'pages.quotaManagement.slotAllocation.kpi.slots': 'slots',
  'pages.quotaManagement.slotAllocation.kpi.totalHint':
    '{duration}-month · {amount}',
  'pages.quotaManagement.slotAllocation.kpi.assignedHint':
    'across {count} divisions',
  'pages.quotaManagement.slotAllocation.kpi.unassignedHint':
    'total minus assigned',
  'pages.quotaManagement.slotAllocation.kpi.unassignedAllHint':
    '{percent}% of {total} slots across all durations',
  'pages.quotaManagement.slotAllocation.table.title': "Assign {name}'s quota",
  'pages.quotaManagement.slotAllocation.table.meta':
    '{count} divisions · {duration}-month · S{from}-S{to}',
  'pages.quotaManagement.slotAllocation.table.holder': 'Holder',
  'pages.quotaManagement.slotAllocation.table.target': 'Target',
  'pages.quotaManagement.slotAllocation.table.unassigned': 'Unassigned',
  'pages.quotaManagement.slotAllocation.table.slot': 'S{slot}',
  'pages.quotaManagement.slotAllocation.table.holderMeta': '{type}',
  'pages.quotaManagement.slotAllocation.table.holderMetaWithChildren':
    '{type} · has children',
  'pages.quotaManagement.slotAllocation.table.committed': '≥ {value}',
  'pages.quotaManagement.slotAllocation.table.legend':
    '≥ marks what is already committed and cannot move',
  'pages.quotaManagement.slotAllocation.table.splitting':
    'Splitting the quota of {name}.',
  'pages.quotaManagement.slotAllocation.table.slotInput':
    '{holder} slot {slot}',
  'pages.quotaManagement.slotAllocation.filter.parent': 'Parent node',
  'pages.quotaManagement.slotAllocation.filter.holders':
    'Filter holders by name',
  'pages.quotaManagement.slotAllocation.filter.holderCount': '{count} holders',
  'pages.quotaManagement.slotAllocation.actions.reset': 'Reset',
  'pages.quotaManagement.slotAllocation.actions.confirm': 'Confirm changes',
  'pages.quotaManagement.slotAllocation.justification.title':
    'Confirm allocation for this node',
  'pages.quotaManagement.slotAllocation.justification.label': 'Justification',
  'pages.quotaManagement.slotAllocation.justification.placeholder':
    'Explain why this node allocation is changing',
  'pages.quotaManagement.slotAllocation.justification.required':
    'Justification is required',
  'pages.quotaManagement.slotAllocation.justification.submit': 'Confirm',
  'pages.quotaManagement.slotAllocation.justification.cancel': 'Cancel',
  'pages.quotaManagement.slotAllocation.unsavedWarning':
    'Reset or confirm unsaved changes before switching level, duration, or month.',
  'pages.quotaManagement.slotAllocation.resetSuccess':
    'Unsaved changes were restored.',
  'pages.quotaManagement.slotAllocation.confirmSuccess':
    'Allocation changes were confirmed.',
  'pages.quotaManagement.slotAllocation.confirmError':
    'Failed to confirm allocation changes.',
  'pages.quotaManagement.slotAllocation.confirmValidation': '{errors}',
  'pages.quotaManagement.slotAllocation.validation.overAllocated':
    'Child allocations cannot exceed the parent available slots.',
  'pages.quotaManagement.slotAllocation.validation.belowCommitted':
    'Allocated slots cannot go below the committed amount.',
  'pages.quotaManagement.slotAllocation.forbidden.title': 'Access denied',
  'pages.quotaManagement.slotAllocation.forbidden.description':
    'You do not have permission to view this allocation plan.',
  'pages.pricingManagement.distribution.title': 'Distribution',
  'pages.pricingManagement.distribution.description':
    'How a fee is collected, or a cashback paid',
  'pages.pricingManagement.distribution.empty':
    'No distributions to display yet.',
  'pages.pricingManagement.distribution.loadError':
    'Failed to load distributions.',
  'pages.pricingManagement.distribution.table.title': 'Distributions',
  'pages.pricingManagement.distribution.table.count': '{count} {kind} methods',
  'pages.pricingManagement.distribution.tabs.fees': 'Fees',
  'pages.pricingManagement.distribution.tabs.cashback': 'Cashback',
  'pages.pricingManagement.distribution.kind.fees': 'Fees',
  'pages.pricingManagement.distribution.kind.cashback': 'Cashback',
  'pages.pricingManagement.distribution.summary.distributions': 'Distributions',
  'pages.pricingManagement.distribution.summary.distributionsHint':
    'reusable across every rule',
  'pages.pricingManagement.distribution.summary.inUse': 'In use',
  'pages.pricingManagement.distribution.summary.inUseHint':
    'of {total} · attached to at least one rule',
  'pages.pricingManagement.distribution.summary.feeMethods': 'Fee methods',
  'pages.pricingManagement.distribution.summary.cashbackMethods':
    'Cashback methods',
  'pages.pricingManagement.distribution.summary.baseHint': 'one is the base',
  'pages.pricingManagement.distribution.filters.name': 'Name',
  'pages.pricingManagement.distribution.filters.namePlaceholder':
    'Search distributions',
  'pages.pricingManagement.distribution.columns.distribution': 'Distribution',
  'pages.pricingManagement.distribution.columns.type': 'Type',
  'pages.pricingManagement.distribution.columns.whenToUse': 'When to use it',
  'pages.pricingManagement.distribution.columns.usedBy': 'Used by',
  'pages.pricingManagement.distribution.baseMethod': 'Base method',
  'pages.pricingManagement.distribution.usage.unused': 'unused',
  'pages.pricingManagement.distribution.usage.rules': '{count} rules',
  'pages.pricingManagement.distribution.actions.new': 'Add distribution',
  'pages.pricingManagement.distribution.actions.update': 'Update',
  'pages.pricingManagement.distribution.actions.delete': 'Delete',
  'pages.pricingManagement.distribution.actions.base': 'Base',
  'pages.pricingManagement.distribution.actions.view': 'View',
  'pages.pricingManagement.distribution.actions.soon':
    'This action will be available soon.',
  'pages.pricingManagement.distribution.create.title': 'New distribution',
  'pages.pricingManagement.distribution.create.crumb': 'Distribution / New',
  'pages.pricingManagement.distribution.create.save': 'Add distribution',
  'pages.pricingManagement.distribution.create.saveSuccess':
    'Distribution created.',
  'pages.pricingManagement.distribution.create.saveError':
    'Failed to create the distribution.',
  'pages.pricingManagement.distribution.edit.title': 'Edit distribution',
  'pages.pricingManagement.distribution.view.title': 'View distribution',
  'pages.pricingManagement.distribution.view.readOnly': 'read only',
  'pages.pricingManagement.distribution.view.liveRules':
    '{count, plural, one {# live rule uses this distribution} other {# live rules use this distribution}}',
  'pages.pricingManagement.distribution.view.liveRulesDetail':
    'Saving changes how they move money from the next request.',
  'pages.pricingManagement.distribution.edit.crumb': 'Distribution / {name}',
  'pages.pricingManagement.distribution.edit.save': 'Save changes',
  'pages.pricingManagement.distribution.edit.saveSuccess':
    'Distribution updated.',
  'pages.pricingManagement.distribution.edit.saveError':
    'Failed to update the distribution.',
  'pages.pricingManagement.distribution.edit.loadError':
    'Failed to load the distribution.',
  'pages.pricingManagement.distribution.delete.title':
    'Delete this distribution?',
  'pages.pricingManagement.distribution.delete.body':
    'No rule uses “{name}”, so nothing being priced today changes.',
  'pages.pricingManagement.distribution.delete.confirm': 'Delete distribution',
  'pages.pricingManagement.distribution.delete.success':
    'Distribution deleted.',
  'pages.pricingManagement.distribution.delete.error':
    'Failed to delete the distribution.',
  'pages.pricingManagement.distribution.form.name': 'Name',
  'pages.pricingManagement.distribution.form.namePlaceholder':
    'e.g. Half upfront, rest monthly',
  'pages.pricingManagement.distribution.form.nameHint':
    'Rules attach this distribution by name.',
  'pages.pricingManagement.distribution.form.nameRequired': 'Name is required.',
  'pages.pricingManagement.distribution.form.type': 'Type',
  'pages.pricingManagement.distribution.form.feesHint':
    'collected from the member',
  'pages.pricingManagement.distribution.form.cashbackHint':
    'given back to the member',
  'pages.pricingManagement.distribution.form.typeHint':
    'Says when a fee is collected. Anything in the payout month is netted from the pot rather than charged as an instalment.',
  'pages.pricingManagement.distribution.form.typeHintCashback':
    'Says when a cashback discount is given. It cannot use the payout month — the member is collecting the pot that month — so that cell is fixed at 0%.',
  'pages.pricingManagement.distribution.form.whenToUse': 'When to use it',
  'pages.pricingManagement.distribution.form.optional': 'optional',
  'pages.pricingManagement.distribution.form.whenToUsePlaceholder':
    'e.g. Use for high-risk members, where getting paid early matters more than the experience',
  'pages.pricingManagement.distribution.form.whenToUseHint':
    "Shown in the list and beside this method in a rule's picker.",
  'pages.pricingManagement.distribution.form.shape': 'Shape',
  'pages.pricingManagement.distribution.form.shapeProgress':
    'per slot · {filled} of {total} durations filled in',
  'pages.pricingManagement.distribution.form.durations': 'Durations',
  'pages.pricingManagement.distribution.form.durationsHint':
    'all three required · each slot column totals 100%',
  'pages.pricingManagement.distribution.form.months': '{count} months',
  'pages.pricingManagement.distribution.form.instalment': 'Instalment',
  'pages.pricingManagement.distribution.form.slot': 'Slot {slot}',
  'pages.pricingManagement.distribution.form.month': 'Month {month}',
  'pages.pricingManagement.distribution.form.cancel': 'Cancel',
  'pages.pricingManagement.rules.title': 'Pricing Rules',
  'pages.pricingManagement.rules.description':
    'One rule per segment · each runs to an end date or a user cap',
  'pages.pricingManagement.rules.empty': 'No pricing rules to display yet.',
  'pages.pricingManagement.rules.loadError': 'Failed to load pricing rules.',
  'pages.pricingManagement.rules.table.title': 'Rules',
  'pages.pricingManagement.rules.table.count': '{count} rules',
  'pages.pricingManagement.rules.summary.rules': 'Rules',
  'pages.pricingManagement.rules.summary.segments': 'Segments covered',
  'pages.pricingManagement.rules.summary.segmentsHint':
    'the rest price at base',
  'pages.pricingManagement.rules.summary.endingSoon': 'Ending within 14 days',
  'pages.pricingManagement.rules.summary.endingSoonNone':
    'nothing lapsing soon',
  'pages.pricingManagement.rules.summary.endingSoonHint': 'lapsing soon',
  'pages.pricingManagement.rules.filters.name': 'Name',
  'pages.pricingManagement.rules.filters.namePlaceholder': 'Search rules',
  'pages.pricingManagement.rules.filters.status': 'Status',
  'pages.pricingManagement.rules.filters.statusAll': 'All',
  'pages.pricingManagement.rules.columns.rule': 'Rule',
  'pages.pricingManagement.rules.columns.reason': 'Reason',
  'pages.pricingManagement.rules.columns.covers': 'Covers',
  'pages.pricingManagement.rules.columns.share': 'Share',
  'pages.pricingManagement.rules.columns.runsUntil': 'Runs until',
  'pages.pricingManagement.rules.columns.users': 'Users',
  'pages.pricingManagement.rules.columns.status': 'Status',
  'pages.pricingManagement.rules.columns.actions': 'Actions',
  'pages.pricingManagement.rules.covers.everyRequest': 'Every request',
  'pages.pricingManagement.rules.share.withOne': 'with 1 other rule',
  'pages.pricingManagement.rules.share.withMany': 'with {count} other rules',
  'pages.pricingManagement.rules.share.theRest': 'the rest',
  'pages.pricingManagement.rules.runsUntil.always': 'always',
  'pages.pricingManagement.rules.runsUntil.daysLeft': '{days} days left',
  'pages.pricingManagement.rules.baseLayer': 'Base layer',
  'pages.pricingManagement.rules.actions.new': 'New rule',
  'pages.pricingManagement.rules.actions.update': 'Update',
  'pages.pricingManagement.rules.actions.removeUsers': 'Remove users',
  'pages.pricingManagement.rules.status.ACTIVE': 'Active',
  'pages.pricingManagement.rules.status.INACTIVE': 'Inactive',
  'pages.pricingManagement.rules.status.DEACTIVATED': 'Deactivated',
  'pages.pricingManagement.rules.status.EXPIRED': 'Expired',
  'pages.pricingManagement.rules.status.alwaysOn': 'always on',
  'pages.pricingManagement.rules.status.deactivateTitle':
    'Deactivate this rule?',
  'pages.pricingManagement.rules.status.deactivateBody':
    'Are you sure you want to deactivate "{name}"? Users in {covers} will be priced by the base layer from their next request.',
  'pages.pricingManagement.rules.status.deactivateOk': 'Deactivate',
  'pages.pricingManagement.rules.status.deactivateHint':
    'You can switch it back on while its segment stays free.',
  'pages.pricingManagement.rules.status.activateTitle': 'Activate this rule?',
  'pages.pricingManagement.rules.status.activateBody':
    'Are you sure you want to activate "{name}"? Users in {covers} will be priced by this rule from their next request.',
  'pages.pricingManagement.rules.status.activateOk': 'Activate',
  'pages.pricingManagement.rules.status.activateHint':
    "Activating fails if this rule's share is more than the segment has left, or if the rule has expired.",
  'pages.pricingManagement.rules.status.usersSoFar': 'Users so far',
  'pages.pricingManagement.rules.status.wasRunningUntil': 'Was running until',
  'pages.pricingManagement.rules.status.activateSuccess': 'Rule activated.',
  'pages.pricingManagement.rules.status.deactivateSuccess': 'Rule deactivated.',
  'pages.pricingManagement.rules.status.activateError':
    'Failed to activate the rule.',
  'pages.pricingManagement.rules.status.deactivateError':
    'Failed to deactivate the rule.',
  'pages.pricingManagement.rules.actions.newSoon':
    'Creating a rule will be available soon.',
  'pages.pricingManagement.rules.actions.removeUsersSoon':
    'Removing users will be available soon.',
  'pages.pricingManagement.rules.removeUsers.title':
    'Remove users from this rule',
  'pages.pricingManagement.rules.removeUsers.description':
    'A removed user is priced by the base layer instead of this rule. There is no way to add a user to a rule — segments decide who it covers.',
  'pages.pricingManagement.rules.removeUsers.uuidsLabel':
    'User UUIDs, comma-separated',
  'pages.pricingManagement.rules.removeUsers.uuidsPlaceholder':
    '3f2b1a10-1111-2222-3333-444444444444, 9e7c4d21-5555-6666-7777-888888888888',
  'pages.pricingManagement.rules.removeUsers.submit': 'Remove from this rule',
  'pages.pricingManagement.rules.removeUsers.removed':
    'Removed {count} · priced at base',
  'pages.pricingManagement.rules.removeUsers.removedEmpty': 'Nobody removed.',
  'pages.pricingManagement.rules.removeUsers.done': 'Done',
  'pages.pricingManagement.rules.removeUsers.required':
    'Enter at least one user UUID.',
  'pages.pricingManagement.rules.removeUsers.invalid':
    'These values are not valid UUIDs: {uuids}',
  'pages.pricingManagement.rules.removeUsers.alreadyExcluded':
    'These users are already removed from this rule.',
  'pages.pricingManagement.rules.removeUsers.loadError':
    'Failed to load removed users.',
  'pages.pricingManagement.rules.removeUsers.submitSuccess':
    'Users were removed from this rule.',
  'pages.pricingManagement.rules.removeUsers.submitError':
    'Failed to remove users from this rule.',
  'pages.pricingManagement.rules.removeUsers.undoError':
    'Failed to restore this user to the rule.',
  'pages.pricingManagement.rules.create.title': 'New rule',
  'pages.pricingManagement.rules.create.crumb': 'Rules / New rule',
  'pages.pricingManagement.rules.create.save': 'Add rule',
  'pages.pricingManagement.rules.create.saveSuccess':
    'Rule created successfully.',
  'pages.pricingManagement.rules.create.saveError':
    'Failed to create the rule.',
  'pages.pricingManagement.rules.create.loadError':
    'Failed to load data for a new rule.',
  'pages.pricingManagement.rules.create.pricingExtra':
    'starts from base pricing · edit any cell',
  'pages.pricingManagement.rules.create.slotsHintExtra':
    'This rule starts from the base definitions and can change any of them.',
  'pages.pricingManagement.rules.form.coversTitle': 'Who it covers',
  'pages.pricingManagement.rules.form.coversExtra': 'exactly one segment',
  'pages.pricingManagement.rules.form.segment': 'Segment',
  'pages.pricingManagement.rules.form.segmentPlaceholder': 'Pick a segment',
  'pages.pricingManagement.rules.form.segmentRequired': 'Select a segment.',
  'pages.pricingManagement.rules.form.taken': '{percent}% taken',
  'pages.pricingManagement.rules.form.segmentsPageHint':
    'Segments are created on the Segments page',
  'pages.pricingManagement.rules.form.scheduleTitle': 'How long it runs',
  'pages.pricingManagement.rules.form.scheduleExtra':
    'optional — it runs until you switch it off',
  'pages.pricingManagement.rules.form.startsAt': 'Start date',
  'pages.pricingManagement.rules.form.endsAt': 'End date',
  'pages.pricingManagement.rules.form.startsAtRequired': 'Select a start date.',
  'pages.pricingManagement.rules.form.endsAtPlaceholder': 'dd/mm/yyyy',
  'pages.pricingManagement.rules.form.noEndDateHint':
    'No end date: this rule runs until someone switches it off.',
  'pages.pricingManagement.rules.form.endAfterStart':
    'End date must be on or after the start date.',
  'pages.pricingManagement.rules.distribution.title': 'Distribution',
  'pages.pricingManagement.rules.distribution.extra': 'how the money moves',
  'pages.pricingManagement.rules.distribution.fees': 'For fees',
  'pages.pricingManagement.rules.distribution.cashback': 'For cashback',
  'pages.pricingManagement.rules.distribution.placeholder':
    'Pick a distribution',
  'pages.pricingManagement.rules.distribution.feesRequired':
    'Select a fees distribution.',
  'pages.pricingManagement.rules.distribution.cashbackRequired':
    'Select a cashback distribution.',
  'pages.pricingManagement.rules.distribution.base': 'base',
  'pages.pricingManagement.rules.distribution.usingBase':
    'Using the base method, {name}.',
  'pages.pricingManagement.rules.distribution.using': 'Using {name}.',
  'pages.pricingManagement.rules.distribution.slotHint':
    'A slot uses whichever method matches its type: fees slots collect on the first, cashback slots pay back on the second.',
  'pages.pricingManagement.rules.distribution.loadError':
    'Could not load distributions.',
  'pages.pricingManagement.rules.edit.title': 'Edit rule',
  'pages.pricingManagement.rules.edit.crumb': 'Rules / {name}',
  'pages.pricingManagement.rules.edit.name': 'Name',
  'pages.pricingManagement.rules.edit.namePlaceholder':
    'e.g. New-user acquisition',
  'pages.pricingManagement.rules.edit.nameHint': 'Shown in the rules table.',
  'pages.pricingManagement.rules.edit.reason': 'Reason',
  'pages.pricingManagement.rules.edit.reasonOptional': 'optional',
  'pages.pricingManagement.rules.edit.reasonPlaceholder':
    'Why this rule exists — e.g. retention test for high-risk bands',
  'pages.pricingManagement.rules.edit.reasonHint':
    'Shown in the rules table so the ruleset explains itself.',
  'pages.pricingManagement.rules.edit.baseBannerTitle':
    'This is the base pricing layer',
  'pages.pricingManagement.rules.edit.baseBannerBody':
    'It prices every request no rule covers, so it has no segment and no end date. Its table is what new rules are pre-filled from.',
  'pages.pricingManagement.rules.edit.pricing': 'Pricing',
  'pages.pricingManagement.rules.edit.durations': 'Durations',
  'pages.pricingManagement.rules.edit.duration': '{months} months',
  'pages.pricingManagement.rules.edit.durationCounts':
    '{fees} fees · {cashback} cashback',
  'pages.pricingManagement.rules.edit.slotsHint':
    'A slot either charges fees or pays cashback, spread across the instalments. Skip limit check opens it to users with a zero credit limit. Deposit requires EGP 100 upfront.',
  'pages.pricingManagement.rules.edit.fees': 'Fees',
  'pages.pricingManagement.rules.edit.cashback': 'Cashback',
  'pages.pricingManagement.rules.edit.columns.slot': 'Slot',
  'pages.pricingManagement.rules.edit.columns.type': 'Type',
  'pages.pricingManagement.rules.edit.columns.rate': 'Rate',
  'pages.pricingManagement.rules.edit.columns.saverSlot': 'Skip limit check',
  'pages.pricingManagement.rules.edit.columns.deposit': 'Deposit',
  'pages.pricingManagement.rules.edit.slotName': 'Slot {position}',
  'pages.pricingManagement.rules.edit.rateFee': '% fee',
  'pages.pricingManagement.rules.edit.rateBack': '% of installment',
  'pages.pricingManagement.rules.edit.save': 'Save changes',
  'pages.pricingManagement.rules.edit.cancel': 'Cancel',
  'pages.pricingManagement.rules.edit.delete': 'Delete',
  'pages.pricingManagement.rules.edit.deleteTitle': 'Delete this rule?',
  'pages.pricingManagement.rules.edit.deleteConfirm':
    '“{name}” stops pricing immediately and its users fall to the base layer. This cannot be undone.',
  'pages.pricingManagement.rules.edit.deleteOk': 'Delete rule',
  'pages.pricingManagement.rules.edit.deleteSuccess':
    'Rule deleted successfully.',
  'pages.pricingManagement.rules.edit.deleteError':
    'Failed to delete the rule.',
  'pages.pricingManagement.rules.edit.saveSuccess':
    'Rule updated successfully.',
  'pages.pricingManagement.rules.edit.saveError': 'Failed to save the rule.',
  'pages.pricingManagement.rules.edit.loadError':
    'This rule could not be found.',
  'pages.pricingManagement.rules.edit.nameRequired':
    'Enter a name for this rule.',
  'pages.pricingManagement.rules.rollout.experimentTitle': 'Experimentation',
  'pages.pricingManagement.rules.rollout.title': 'Rollout',
  'pages.pricingManagement.rules.rollout.label': 'Rollout',
  'pages.pricingManagement.rules.rollout.required':
    'Enter a rollout from 1 to 100.',
  'pages.pricingManagement.rules.rollout.shareOf': 'Share of {name}',
  'pages.pricingManagement.rules.rollout.onlyChange':
    'the one thing you can change',
  'pages.pricingManagement.rules.rollout.liveTitle':
    'This rule is live — only the rollout share can change',
  'pages.pricingManagement.rules.rollout.liveBody':
    'A live rule cannot be edited, except to raise its rollout. Inactive, deactivated, and expired rules can change every field.',
  'pages.pricingManagement.rules.rollout.liveHint':
    'Live at {share}%. You can raise this up to {max}%; lowering it means deactivating the rule and rolling it out again.',
  'pages.pricingManagement.rules.rollout.createHint':
    'Everyone in the segment is priced by this rule.',
  'pages.pricingManagement.rules.rollout.editHint':
    'Everyone in {name} is priced by this rule.',
  'pages.pricingManagement.rules.rollout.cannotLower':
    'Rollout cannot go below {share}% while this rule is live.',
  'pages.pricingManagement.rules.rollout.save': 'Save rollout',
  'pages.pricingManagement.rules.running.title': 'What is running',
  'pages.pricingManagement.rules.running.readOnly': 'read only',
  'pages.pricingManagement.rules.running.runs': 'Runs',
  'pages.pricingManagement.rules.running.users': 'Users so far',
  'pages.pricingManagement.rules.running.yes': 'Yes',
  'pages.pricingManagement.rules.running.feesDistribution': 'Fees: {name}',
  'pages.pricingManagement.rules.running.cashbackDistribution':
    'Cashback: {name}',
  'pages.accessManagement.addRole': 'Add Role',
  'pages.accessManagement.editRole': 'Edit Role',
  'pages.accessManagement.create': 'Create',
  'pages.accessManagement.update': 'Update',
  'pages.accessManagement.createSuccess': 'Role created successfully',
  'pages.accessManagement.createError': 'Failed to create role',
  'pages.accessManagement.updateSuccess': 'Role updated successfully',
  'pages.accessManagement.updateError': 'Failed to update role',
  'pages.accessManagement.noRoleSelected': 'No role selected',
  'pages.accessManagement.name': 'Name',
  'pages.accessManagement.name.required': 'Please enter the name',
  'pages.accessManagement.name.placeholder': 'Enter role name',
  'pages.accessManagement.description': 'Description',
  'pages.accessManagement.description.required': 'Please enter the description',
  'pages.accessManagement.description.placeholder': 'Enter role description',
  'pages.accessManagement.group': 'Group',
  'pages.accessManagement.group.required': 'Please select a group',
  'pages.accessManagement.group.placeholder': 'Select a group',
  'pages.accessManagement.levelCode': 'Level Code',
  'pages.accessManagement.levelCode.required': 'Please enter the level code',
  'pages.accessManagement.levelCode.placeholder': 'Enter level code',
  'pages.cardCashbackOffers.title': 'Card CashBack (Migrated)',
  'pages.cardCashbackOffers.search': 'Search',
  'pages.cardCashbackOffers.clear': 'Clear',
  'pages.cardCashbackOffers.filters.status': 'Status',
  'pages.cardCashbackOffers.filters.startDate': 'Start Date',
  'pages.cardCashbackOffers.filters.endDate': 'End Date',
  'pages.cardCashbackOffers.columns.guid': 'GUID',
  'pages.cardCashbackOffers.columns.value': 'Value',
  'pages.cardCashbackOffers.columns.capping': 'Capping',
  'pages.cardCashbackOffers.columns.minimumSpending': 'Minimum Spend',
  'pages.cardCashbackOffers.columns.startDate': 'Start Date',
  'pages.cardCashbackOffers.columns.endDate': 'End Date',
  'pages.cardCashbackOffers.columns.maxTransactions': 'Max Transactions',
  'pages.cardCashbackOffers.columns.status': 'Status',
  'pages.cardCashbackOffers.columns.actions': 'Actions',
  'pages.cardCashbackOffers.status.inactive': 'Inactive',
  'pages.cardCashbackOffers.status.all': 'All',
  'pages.cardCashbackOffers.status.active': 'Active',
  'pages.cardCashbackOffers.status.expired': 'Expired',
  'pages.cardCashbackOffers.status.canceled': 'Canceled',
  'pages.cardCashbackOffers.status.unknown': 'Unknown',
  'pages.cardCashbackOffers.actions.add': 'Add CashBack Offer',
  'pages.cardCashbackOffers.actions.more': 'More Actions',
  'pages.cardCashbackOffers.actions.edit': 'Edit',
  'pages.cardCashbackOffers.actions.cancel': 'Cancel',
  'pages.cardCashbackOffers.actions.delete': 'Delete',
  'pages.cardCashbackOffers.actions.keep': 'Keep',
  'pages.cardCashbackOffers.form.addTitle': 'Add CashBack Offer',
  'pages.cardCashbackOffers.form.editTitle': 'Edit CashBack Offer',
  'pages.cardCashbackOffers.form.type': 'Cashback Type',
  'pages.cardCashbackOffers.form.percentage': 'Percentage',
  'pages.cardCashbackOffers.form.amount': 'Fixed Amount',
  'pages.cardCashbackOffers.form.value': 'CashBack Value',
  'pages.cardCashbackOffers.form.valuePercentage': 'Percentage',
  'pages.cardCashbackOffers.form.valueAmount': 'Fixed Amount',
  'pages.cardCashbackOffers.form.capping': 'Capping',
  'pages.cardCashbackOffers.form.minimumSpending': 'Minimum Spending Limit',
  'pages.cardCashbackOffers.form.startDate': 'Start Date',
  'pages.cardCashbackOffers.form.endDate': 'End Date',
  'pages.cardCashbackOffers.form.maxTransactions':
    'Maximum Transactions Per User',
  'pages.cardCashbackOffers.form.save': 'Save',
  'pages.cardCashbackOffers.form.saveOffer': 'Save Offer',
  'pages.cardCashbackOffers.form.cancel': 'Cancel',
  'pages.cardCashbackOffers.confirm.cancelTitle': 'Cancel CashBack offer',
  'pages.cardCashbackOffers.confirm.cancel':
    'Are you sure you want to cancel this offer?',
  'pages.cardCashbackOffers.confirm.deleteTitle': 'Delete CashBack offer',
  'pages.cardCashbackOffers.confirm.delete':
    'Are you sure you want to delete this offer?',
  'pages.cardCashbackOffers.messages.loadFailed':
    'Unable to load CashBack offers.',
  'pages.cardCashbackOffers.messages.created':
    'CashBack offer created successfully.',
  'pages.cardCashbackOffers.messages.updated':
    'CashBack offer updated successfully.',
  'pages.cardCashbackOffers.messages.canceled':
    'CashBack offer canceled successfully.',
  'pages.cardCashbackOffers.messages.deleted':
    'CashBack offer deleted successfully.',
  'pages.cardCashbackOffers.messages.saveFailed':
    'Unable to save the CashBack offer.',
  'pages.cardCashbackOffers.messages.openEditFromList':
    'Open the offer from the CashBack list to load its data.',
  'pages.cardCashbackOffers.messages.cancelFailed':
    'Unable to cancel the CashBack offer.',
  'pages.cardCashbackOffers.messages.deleteFailed':
    'Unable to delete the CashBack offer.',
  'pages.cardCashbackOffers.permissions.viewDenied':
    'You do not have permission to view Card CashBack offers.',
  'pages.cardCashbackOffers.validation.positiveValue':
    'Value must be greater than zero.',
  'pages.cardCashbackOffers.validation.endAfterStart':
    'End date must be after start date.',
  'pages.cardCashbackOffers.validation.positiveTransactions':
    'Maximum transactions must be greater than zero.',
  'pages.accessManagement.manageGroups': 'Manage groups',
  'pages.accessManagement.addGroup': 'Add group',
  'pages.accessManagement.editGroup': 'Edit group',
  'pages.accessManagement.groupName.placeholder': 'Enter group name',
  'pages.accessManagement.groupDescription.placeholder':
    'Enter group description',
  'pages.accessManagement.groupCreateSuccess': 'Role group created',
  'pages.accessManagement.groupCreateError': 'Failed to create role group',
  'pages.accessManagement.groupUpdateSuccess': 'Role group updated',
  'pages.accessManagement.groupUpdateError': 'Failed to update role group',
  'pages.accessManagement.groupDelete': 'Delete',
  'pages.accessManagement.groupDeleteConfirm': 'Delete this role group?',
  'pages.accessManagement.groupDeleteSuccess': 'Role group deleted',
  'pages.accessManagement.groupDeleteError':
    'This group still has roles, or the delete failed',
  'pages.accessManagement.groupsLoadError': 'Failed to load role groups',
  'pages.accessManagement.noGroupSelected': 'No role group selected',
  'pages.accessManagement.actions': 'Actions',
  'pages.pricingManagement.segments.title': 'Segments',
  'pages.pricingManagement.segments.description':
    'Who a rule applies to · one rule per segment.',
  'pages.pricingManagement.segments.empty': 'No segments to display yet.',
  'pages.pricingManagement.segments.unnamed': 'Untitled segment',
  'pages.pricingManagement.segments.definedCount': '{count} defined',
  'pages.pricingManagement.segments.rankNote':
    'When a user matches several segments, the highest-ranked one decides which rule prices them. Use Change ranking to reorder.',
  'pages.pricingManagement.segments.ranking.hint':
    'Drag the rows into the order you want.',
  'pages.pricingManagement.segments.ranking.handle': 'Drag to reorder',
  'pages.pricingManagement.segments.columns.rank': 'Rank',
  'pages.pricingManagement.segments.columns.name': 'Segment',
  'pages.pricingManagement.segments.columns.covers': 'Covers',
  'pages.pricingManagement.segments.columns.liveRules': 'Live rules',
  'pages.pricingManagement.segments.columns.liveRulesCount':
    '{count, plural, one {# live} other {# live}}',
  'pages.pricingManagement.segments.columns.noLiveRules': 'none',
  'pages.pricingManagement.segments.actions.new': 'New segment',
  'pages.pricingManagement.segments.actions.edit': 'Update',
  'pages.pricingManagement.segments.actions.delete': 'Delete',
  'pages.pricingManagement.segments.actions.add': 'Add segment',
  'pages.pricingManagement.segments.actions.save': 'Save changes',
  'pages.pricingManagement.segments.actions.cancel': 'Cancel',
  'pages.pricingManagement.segments.actions.changeRanking': 'Change ranking',
  'pages.pricingManagement.segments.actions.saveRanking': 'Save ranking',
  'pages.pricingManagement.segments.form.addTitle': 'New segment',
  'pages.pricingManagement.segments.form.editTitle': 'Edit segment',
  'pages.pricingManagement.segments.form.nameTitle': 'Name',
  'pages.pricingManagement.segments.form.namePlaceholder':
    'e.g. VIP · low risk',
  'pages.pricingManagement.segments.form.nameExtra':
    'Rules attach this segment by name.',
  'pages.pricingManagement.segments.form.audienceTitle': 'Audience',
  'pages.pricingManagement.segments.form.required': 'required',
  'pages.pricingManagement.segments.userType.label': 'User type',
  'pages.pricingManagement.segments.userType.new': 'New',
  'pages.pricingManagement.segments.userType.existing': 'Existing',
  'pages.pricingManagement.segments.userType.both':
    'Both New and Existing users.',
  'pages.pricingManagement.segments.userType.only': '{type} users only.',
  'pages.pricingManagement.segments.accountType.label': 'Account type',
  'pages.pricingManagement.segments.accountType.everyone': 'Everyone',
  'pages.pricingManagement.segments.accountType.individualOnly':
    'Individual only',
  'pages.pricingManagement.segments.accountType.corporateOnly':
    'Corporate only',
  'pages.pricingManagement.segments.accountType.everyoneHelp':
    'Individual and corporate accounts.',
  'pages.pricingManagement.segments.accountType.individualOnlyHelp':
    'Individual accounts only.',
  'pages.pricingManagement.segments.accountType.whichAccounts':
    'Which accounts',
  'pages.pricingManagement.segments.accountType.whichAccountsHint':
    'empty = every corporate account',
  'pages.pricingManagement.segments.accountType.anyCorporateAccount':
    'Any corporate account',
  'pages.pricingManagement.segments.accountType.leaveEmpty':
    'Leave empty to cover every corporate account.',
  'pages.pricingManagement.segments.accountType.namedAccounts':
    '{count, plural, one {Only the one named account.} other {Only the # named accounts.}}',
  'pages.pricingManagement.segments.select.selectAll': 'Select all · {details}',
  'pages.pricingManagement.segments.select.optionCount':
    '{count, plural, one {# option} other {# options}}',
  'pages.pricingManagement.segments.select.matchCount':
    '{count, plural, one {# match} other {# matches}}',
  'pages.pricingManagement.segments.select.selectedCount': '{count} selected',
  'pages.pricingManagement.segments.select.ratio': '{count} of {total}',
  'pages.pricingManagement.segments.select.searchAccounts': 'Search accounts',
  'pages.pricingManagement.segments.select.clear': 'Clear',
  'pages.pricingManagement.segments.select.noMatch':
    'Nothing matches “{query}”.',
  'pages.pricingManagement.segments.attributes.title': 'User attributes',
  'pages.pricingManagement.segments.attributes.optional': 'optional',
  'pages.pricingManagement.segments.attributes.count': '{count} set',
  'pages.pricingManagement.segments.attributes.add': 'Add an attribute',
  'pages.pricingManagement.segments.attributes.added': 'added',
  'pages.pricingManagement.segments.attributes.number': 'number',
  'pages.pricingManagement.segments.attributes.numberWithUnit':
    'number · {unit}',
  'pages.pricingManagement.segments.attributes.operatorIs': 'is',
  'pages.pricingManagement.segments.attributes.operatorIsOneOf': 'is one of',
  'pages.pricingManagement.segments.attributes.operatorRange': 'Range',
  'pages.pricingManagement.segments.attributes.bounds': '{min} – {max}',
  'pages.pricingManagement.segments.attributes.unknown':
    'Not in the attribute catalogue — kept as it is until you remove it.',
  'pages.pricingManagement.segments.attributes.anyValue': 'Any {label}',
  'pages.pricingManagement.segments.attributes.remove': 'Remove',
  'pages.pricingManagement.segments.attributes.matchAll': 'Match all',
  'pages.pricingManagement.segments.attributes.matchAny': 'Match any',
  'pages.pricingManagement.segments.attributes.and': 'AND',
  'pages.pricingManagement.segments.attributes.or': 'OR',
  'pages.pricingManagement.segments.attributes.summaryAll':
    'A user must satisfy every one of these: {list}.',
  'pages.pricingManagement.segments.attributes.summaryAny':
    'A user must satisfy any one of these: {list}.',
  'pages.pricingManagement.segments.attributes.emptyHint':
    'Age, location, gender, risk band or credit score — with ranges or exact values.',
  'pages.pricingManagement.segments.summary.label': 'Covers',
  'pages.pricingManagement.segments.summary.everyUser': 'Every user',
  'pages.pricingManagement.segments.summary.userTypeOnly': '{type} users',
  'pages.pricingManagement.segments.summary.individualOnly': 'Individual only',
  'pages.pricingManagement.segments.summary.corporateAny': 'Corporate only',
  'pages.pricingManagement.segments.summary.corporateNamed':
    'Corporate {names}',
  'pages.pricingManagement.segments.summary.corporateAll':
    'Corporate — all accounts selected',
  'pages.pricingManagement.segments.summary.corporateMore':
    'Corporate {names} +{count} more selected',
  'pages.pricingManagement.segments.summary.and': '{first} and {second}',
  'pages.pricingManagement.segments.summary.or': '{first} or {second}',
  'pages.pricingManagement.segments.summary.attrAny': '{label} any',
  'pages.pricingManagement.segments.summary.attrIn': '{label} {values}',
  'pages.pricingManagement.segments.summary.attrGte': '{label} ≥ {value}',
  'pages.pricingManagement.segments.summary.attrGt': '{label} > {value}',
  'pages.pricingManagement.segments.summary.attrLte': '{label} ≤ {value}',
  'pages.pricingManagement.segments.summary.attrLt': '{label} < {value}',
  'pages.pricingManagement.segments.summary.attrBetween': '{label} {from}–{to}',
  'pages.pricingManagement.segments.summary.attrEq': '{label} = {value}',
  'pages.pricingManagement.segments.validation.nameRequired': 'Required.',
  'pages.pricingManagement.segments.validation.nameMax':
    'Keep the name under {max} characters.',
  'pages.pricingManagement.segments.validation.userTypeRequired':
    'Pick at least one.',
  'pages.pricingManagement.segments.validation.valuesRequired':
    'Select at least one value.',
  'pages.pricingManagement.segments.validation.valueRequired': 'Enter a value.',
  'pages.pricingManagement.segments.validation.rangeTopRequired':
    'Enter the top of the range.',
  'pages.pricingManagement.segments.validation.rangeInverted':
    'The range is inverted.',
  'pages.pricingManagement.segments.banner.liveRules':
    '{count, plural, one {# live rule uses this segment} other {# live rules use this segment}}',
  'pages.pricingManagement.segments.banner.liveRulesDetail':
    'Saving a change sends {count, plural, one {it} other {them}} back to Finance and Risk.',
  'pages.pricingManagement.segments.confirm.liveTitle':
    'Save changes to a live segment?',
  'pages.pricingManagement.segments.confirm.liveBody':
    '{count, plural, one {# live rule uses} other {# live rules use}} this segment. Saving changes who {count, plural, one {it prices} other {they price}} from the next request.',
  'pages.pricingManagement.segments.confirm.liveOk': 'Save changes',
  'pages.pricingManagement.segments.confirm.discardTitle':
    'Discard your changes?',
  'pages.pricingManagement.segments.confirm.discardBody':
    'The changes you made to this segment will be lost.',
  'pages.pricingManagement.segments.confirm.discardOk': 'Discard',
  'pages.pricingManagement.segments.confirm.deleteTitle':
    'Delete this segment?',
  'pages.pricingManagement.segments.confirm.deleteBody':
    'No rule uses “{name}”, so nothing being priced today changes. Deleting is permanent.',
  'pages.pricingManagement.segments.confirm.deleteCovers': 'Covers: {covers}',
  'pages.pricingManagement.segments.confirm.blockedTitle':
    'This segment is in use',
  'pages.pricingManagement.segments.confirm.blockedBody':
    '“{name}” cannot be deleted while {count, plural, one {# live rule uses} other {# live rules use}} it. Detach it first, then delete.',
  'pages.pricingManagement.segments.confirm.blockedOk': 'Close',
  'pages.pricingManagement.segments.confirm.rankingTitle':
    'Change segment ranking?',
  'pages.pricingManagement.segments.confirm.rankingBody':
    'Are you sure you want to change the ranking? The new order takes effect on the next pricing calculation.',
  'pages.pricingManagement.segments.confirm.rankingOk': 'Confirm',
  'pages.pricingManagement.segments.messages.created':
    'Segment created successfully',
  'pages.pricingManagement.segments.messages.updated':
    'Segment updated successfully',
  'pages.pricingManagement.segments.messages.createFailed':
    'Failed to create the segment.',
  'pages.pricingManagement.segments.messages.updateFailed':
    'Failed to update the segment.',
  'pages.pricingManagement.segments.messages.loadFailed':
    'Failed to load the segment form.',
  'pages.pricingManagement.segments.messages.notFound':
    'That segment could not be loaded.',
  'pages.pricingManagement.segments.messages.catalogueFailed':
    'Failed to load the attribute catalogue.',
  'pages.pricingManagement.segments.messages.accountsFailed':
    'Failed to load corporate accounts.',
  'pages.pricingManagement.segments.messages.deleted': 'Segment deleted.',
  'pages.pricingManagement.segments.messages.rankingSaved': 'Ranking saved.',
  'pages.pricingManagement.segments.messages.rankingFailed':
    'Could not save the new ranking.',
  'pages.pricingManagement.segments.messages.deleteFailed':
    'Could not delete the segment.',
  'pages.pricingManagement.segments.messages.unsupportedShape':
    'This segment combines its conditions in a way the portal cannot edit yet.',
  'pages.pricingManagement.audit.title': 'Audit',
  'pages.pricingManagement.audit.description':
    'Every change to pricing rules, segments and base pricing, newest first. Entries cannot be edited or removed.',
  'pages.pricingManagement.audit.table.title': 'Audit log',
  'pages.pricingManagement.audit.table.count':
    '{count, plural, one {# record} other {# records}}',
  'pages.pricingManagement.audit.loadError': 'Failed to load the audit log.',
  'pages.pricingManagement.audit.empty': 'No changes have been recorded yet.',
  'pages.pricingManagement.audit.emptyFiltered.title':
    'No entry matches this filter',
  'pages.pricingManagement.audit.emptyFiltered.description':
    'Every change is still recorded — clear the filter to see the full history.',
  'pages.pricingManagement.audit.emptyFiltered.clear': 'Clear filter',
  'pages.pricingManagement.audit.filters.action': 'Action',
  'pages.pricingManagement.audit.filters.allActions': 'All actions',
  'pages.pricingManagement.audit.filters.date': 'Date',
  'pages.pricingManagement.audit.filters.reset': 'Reset',
  'pages.pricingManagement.audit.columns.action': 'Action',
  'pages.pricingManagement.audit.columns.whatHappened': 'What happened',
  'pages.pricingManagement.audit.columns.appliedTo': 'Applied to',
  'pages.pricingManagement.audit.columns.date': 'Date',
  'pages.pricingManagement.audit.columns.admin': 'Admin',
  'pages.pricingManagement.audit.actions.created': 'Created',
  'pages.pricingManagement.audit.actions.edited': 'Edited',
  'pages.pricingManagement.audit.actions.deleted': 'Deleted',
  'pages.pricingManagement.audit.actions.reordered': 'Reordered',
  'pages.pricingManagement.audit.actions.activated': 'Activated',
  'pages.pricingManagement.audit.actions.deactivated': 'Deactivated',
  'pages.pricingManagement.audit.actions.usersExcluded': 'Users excluded',
  'pages.pricingManagement.audit.actions.userExclusionsRemoved':
    'Exclusions removed',
  'pages.pricingManagement.audit.targetTypes.pricingRule': 'Rule',
  'pages.pricingManagement.audit.targetTypes.segment': 'Segment',
  'pages.pricingManagement.audit.targetTypes.basePricing': 'Base pricing',
  'pages.pricingManagement.audit.sentence.rule': 'rule “{name}”',
  'pages.pricingManagement.audit.sentence.ruleUnnamed': 'a rule',
  'pages.pricingManagement.audit.sentence.segment': 'segment “{name}”',
  'pages.pricingManagement.audit.sentence.segmentUnnamed': 'a segment',
  'pages.pricingManagement.audit.sentence.basePricing': 'base pricing',
  'pages.pricingManagement.audit.sentence.Created': 'Created {target}',
  'pages.pricingManagement.audit.sentence.Edited': 'Edited {target}',
  'pages.pricingManagement.audit.sentence.Deleted': 'Deleted {target}',
  'pages.pricingManagement.audit.sentence.Reordered': 'Segment ranking changed',
  'pages.pricingManagement.audit.sentence.Activated': 'Activated {target}',
  'pages.pricingManagement.audit.sentence.Deactivated': 'Deactivated {target}',
  'pages.pricingManagement.audit.sentence.UsersExcluded':
    '{count, plural, one {# user} other {# users}} excluded from {target}',
  'pages.pricingManagement.audit.sentence.UserExclusionsRemoved':
    '{count, plural, one {# user} other {# users}} put back on {target}',
  'pages.pricingManagement.audit.changes.field': 'Field',
  'pages.pricingManagement.audit.changes.before': 'Before',
  'pages.pricingManagement.audit.changes.after': 'After',
  'pages.pricingManagement.audit.values.yes': 'Yes',
  'pages.pricingManagement.audit.values.no': 'No',
  'pages.pricingManagement.audit.values.userType.new': 'New',
  'pages.pricingManagement.audit.values.userType.existing': 'Existing',
  'pages.pricingManagement.audit.values.userType.both': 'Both',
  'pages.pricingManagement.audit.values.accountType.everyone': 'Everyone',
  'pages.pricingManagement.audit.values.accountType.individualOnly':
    'Individual only',
  'pages.pricingManagement.audit.values.accountType.corporateOnly':
    'Corporate only',
  'pages.pricingManagement.audit.fields.Name': 'Name',
  'pages.pricingManagement.audit.fields.Reason': 'Reason',
  'pages.pricingManagement.audit.fields.SegmentId': 'Segment',
  'pages.pricingManagement.audit.fields.IsActive': 'Active',
  'pages.pricingManagement.audit.fields.ActivatedAt': 'Activated at',
  'pages.pricingManagement.audit.fields.DeactivatedAt': 'Deactivated at',
  'pages.pricingManagement.audit.fields.StartsAt': 'Starts at',
  'pages.pricingManagement.audit.fields.EndsAt': 'Ends at',
  'pages.pricingManagement.audit.fields.RolloutPercentage': 'Rollout %',
  'pages.pricingManagement.audit.fields.Ranges': 'Ranges',
  'pages.pricingManagement.audit.fields.Slots': 'Slots',
  'pages.pricingManagement.audit.fields.Priority': 'Priority',
  'pages.pricingManagement.audit.fields.UserType': 'User type',
  'pages.pricingManagement.audit.fields.AccountType': 'Account type',
  'pages.pricingManagement.audit.fields.CorporateAccountIds':
    'Corporate accounts',
  'pages.pricingManagement.audit.fields.Attributes': 'Attributes',
  'pages.pricingManagement.audit.fields.SegmentIds': 'Segment order',
  'pages.pricingManagement.audit.fields.UserUuids': 'Users',
  'pages.cardPromoCodeCampaigns.title': 'Card Promo Code Campaign (Migrated)',
  'pages.cardPromoCodeCampaigns.search': 'Search',
  'pages.cardPromoCodeCampaigns.clear': 'Clear',
  'pages.cardPromoCodeCampaigns.status.active': 'Active',
  'pages.cardPromoCodeCampaigns.status.all': 'All',
  'pages.cardPromoCodeCampaigns.status.inactive': 'Inactive',
  'pages.cardPromoCodeCampaigns.status.expired': 'Expired',
  'pages.cardPromoCodeCampaigns.status.deactivated': 'Deactivated',
  'pages.cardPromoCodeCampaigns.compatibility.addOnTop': 'Add On Top',
  'pages.cardPromoCodeCampaigns.compatibility.notCompatible': 'Not Compatible',
  'pages.cardPromoCodeCampaigns.compatibility.override': 'Override',
  'pages.cardPromoCodeCampaigns.actions.create': 'Create Campaign',
  'pages.cardPromoCodeCampaigns.actions.activate': 'Activate',
  'pages.cardPromoCodeCampaigns.actions.deactivate': 'Deactivate',
  'pages.cardPromoCodeCampaigns.actions.confirm': 'Confirm',
  'pages.cardPromoCodeCampaigns.actions.cancel': 'Cancel',
  'pages.cardPromoCodeCampaigns.form.title': 'New Card Promo Code Campaign',
  'pages.cardPromoCodeCampaigns.form.steps.benefits': 'Benefits',
  'pages.cardPromoCodeCampaigns.form.steps.configuration':
    'Campaign configuration',
  'pages.cardPromoCodeCampaigns.form.steps.eligibility': 'User Eligibility',
  'pages.cardPromoCodeCampaigns.form.discountType': 'Discount',
  'pages.cardPromoCodeCampaigns.form.discountValue': 'Discount value',
  'pages.cardPromoCodeCampaigns.form.percentage': 'Percentage',
  'pages.cardPromoCodeCampaigns.form.amount': 'Fixed Amount',
  'pages.cardPromoCodeCampaigns.form.compatibility': 'Discount Compatibility',
  'pages.cardPromoCodeCampaigns.form.campaignName': 'Title',
  'pages.cardPromoCodeCampaigns.form.description': 'Description',
  'pages.cardPromoCodeCampaigns.form.startDate': 'Start date and time',
  'pages.cardPromoCodeCampaigns.form.endDate': 'Expiry date and time',
  'pages.cardPromoCodeCampaigns.form.maxRedemptions': 'Maximum redemptions',
  'pages.cardPromoCodeCampaigns.form.collectionWindow':
    'Collection window in days',
  'pages.cardPromoCodeCampaigns.form.zeroUnlimited': 'Use 0 for unlimited.',
  'pages.cardPromoCodeCampaigns.form.promoCode': 'Promo code',
  'pages.cardPromoCodeCampaigns.form.promoCodeHint':
    'Use 3–30 English letters or numbers. Do not use spaces or symbols. Uppercase and lowercase letters are treated the same.',
  'pages.cardPromoCodeCampaigns.form.eligibility': 'Eligible users',
  'pages.cardPromoCodeCampaigns.form.allUsers': 'All users',
  'pages.cardPromoCodeCampaigns.form.uploadUsers': 'Upload user list',
  'pages.cardPromoCodeCampaigns.form.excelRequirementsTitle':
    'How to prepare your Excel file',
  'pages.cardPromoCodeCampaigns.form.excelFileTypes':
    'Upload an .xlsx or .xls file.',
  'pages.cardPromoCodeCampaigns.form.excelFirstWorksheet':
    'We read only the first worksheet.',
  'pages.cardPromoCodeCampaigns.form.excelColumnA':
    'Put each eligible user value in column A.',
  'pages.cardPromoCodeCampaigns.form.excelNoHeader':
    'Do not add a header row. Every nonempty cell in column A will be imported.',
  'pages.cardPromoCodeCampaigns.form.uploadPrompt':
    'Select an Excel eligibility file',
  'pages.cardPromoCodeCampaigns.form.previous': 'Previous',
  'pages.cardPromoCodeCampaigns.form.next': 'Next',
  'pages.cardPromoCodeCampaigns.form.create': 'Create Campaign',
  'pages.cardPromoCodeCampaigns.form.cancel': 'Cancel',
  'pages.cardPromoCodeCampaigns.validation.promoCodeRequired':
    'Enter a promo code.',
  'pages.cardPromoCodeCampaigns.validation.promoCodeLength':
    'Promo code must be between 3 and 30 characters.',
  'pages.cardPromoCodeCampaigns.validation.promoCodeCharacters':
    'Use English letters and numbers only. Spaces and symbols are not allowed.',
  'pages.cardPromoCodeCampaigns.messages.created':
    'Campaign created successfully.',
  'pages.cardPromoCodeCampaigns.messages.activated':
    'Campaign activated successfully.',
  'pages.cardPromoCodeCampaigns.messages.deactivated':
    'Campaign deactivated successfully.',
  'pages.circlesMigrated.title': 'Circles (Migrated)',
  'pages.circlesMigrated.yes': 'Yes',
  'pages.circlesMigrated.no': 'No',
  'pages.circlesMigrated.type.real': 'Real',
  'pages.circlesMigrated.type.overbooking': 'Overbooking',
  'pages.circlesMigrated.visibility.public': 'Public',
  'pages.circlesMigrated.visibility.private': 'Private',
  'pages.circlesMigrated.column.id': 'ID',
  'pages.circlesMigrated.column.type': 'Type',
  'pages.circlesMigrated.column.started': 'Started',
  'pages.circlesMigrated.column.startedOn': 'Started On',
  'pages.circlesMigrated.column.ended': 'Ended',
  'pages.circlesMigrated.column.payoutAmount': 'Payout Amount',
  'pages.circlesMigrated.column.installment': 'Installment',
  'pages.circlesMigrated.column.availableSlots': 'Available Slots',
  'pages.circlesMigrated.column.circleType': 'Circle Type',
  'pages.circlesMigrated.column.createdAt': 'Created At',
  'pages.circlesMigrated.filter.all': 'All',
  'pages.circlesMigrated.filter.startedFrom': 'Started From',
  'pages.circlesMigrated.filter.startedTo': 'Started To',
  'pages.circlesMigrated.filter.payoutFrom': 'Payout From',
  'pages.circlesMigrated.filter.payoutTo': 'Payout To',
  'pages.circlesMigrated.filter.status': 'Status',
  'pages.circlesMigrated.filter.status.notStarted': 'Not Started',
  'pages.circlesMigrated.filter.status.started': 'Started',
  'pages.circlesMigrated.filter.status.ended': 'Ended',
  'pages.circlesMigrated.filter.completeness': 'Slots Availability',
  'pages.circlesMigrated.filter.onlyIncomplete': 'Only Incomplete',
  'pages.circlesMigrated.filter.onlyComplete': 'Only Complete',
  'pages.circlesMigrated.filter.visibility': 'Circle Type',
  'pages.circlesMigrated.filter.slots': 'Duration',
  'pages.circlesMigrated.filter.slots.months': '{count} Months',
  'pages.circlesMigrated.action.search': 'Search',
  'pages.circlesMigrated.action.clear': 'Clear',
  'pages.circlesMigrated.action.createCircle': 'Create New Circle',
  'pages.circlesMigrated.action.manageEdl': 'Manage EDL',
  'pages.circlesMigrated.action.startAll': 'Start All Circles',
  'pages.circlesMigrated.action.create': 'Create',
  'pages.circlesMigrated.action.apply': 'Apply',
  'pages.circlesMigrated.action.confirm': 'Confirm',
  'pages.circlesMigrated.action.cancel': 'Cancel',
  'pages.circlesMigrated.confirm.startAll':
    'Are you sure you want to start all circles?',
  'pages.circlesMigrated.form.duration': 'Number of Months',
  'pages.circlesMigrated.form.duration.required':
    'Please select the number of months',
  'pages.circlesMigrated.form.noOfCircles': 'Circles Number',
  'pages.circlesMigrated.form.noOfCircles.required':
    'Please enter the number of circles',
  'pages.circlesMigrated.form.startDate': 'Start Date',
  'pages.circlesMigrated.form.startDate.required': 'Please select a start date',
  'pages.circlesMigrated.form.overbooking': 'Overbooking Circles',
  'pages.circlesMigrated.form.freeSlotsForPosition':
    'FREE slots for position ({position})',
  'pages.circlesMigrated.form.slotsForPosition':
    'Slots for position ({position})',
  'pages.circlesMigrated.form.unlockEdl': 'UnLock EDL',
  'pages.circlesMigrated.form.blockEdl': 'Block EDL',
  'pages.circlesMigrated.messages.fetchFailed': 'Failed to fetch circles',
  'pages.circlesMigrated.messages.durationsFailed':
    'Failed to load circle durations',
  'pages.circlesMigrated.messages.createSuccess':
    'Circles created successfully',
  'pages.circlesMigrated.messages.createFailed': 'Failed to create circles',
  'pages.circlesMigrated.messages.manageEdlSuccess': 'EDL updated successfully',
  'pages.circlesMigrated.messages.manageEdlFailed': 'Failed to update EDL',
  'pages.circlesMigrated.messages.startAllSuccess':
    'Circles started successfully',
  'pages.circlesMigrated.messages.startAllFailed': 'Failed to start circles',
  'pages.circlesMigrated.messages.noListPermission':
    'You do not have permission to view the circles list.',
  'pages.bundlingEngine.rules.title': 'Bundling Engine',
  'pages.bundlingEngine.rules.description':
    'Manage the rules that bundle popular circle slots with hard-to-fill ones.',
  'pages.bundlingEngine.rules.empty': 'No bundling rules to display yet.',
  'pages.bundlingEngine.rules.loadError': 'Failed to load bundling rules.',
  'pages.bundlingEngine.rules.table.title': 'Rules',
  'pages.bundlingEngine.rules.create': 'New rule',
  'pages.bundlingEngine.form.title': 'New rule',
  'pages.bundlingEngine.form.description':
    'It goes live at the lowest priority. After that it can’t be edited: to change it, deactivate it and create a new rule.',
  'pages.bundlingEngine.form.card.type': 'Bundle type',
  'pages.bundlingEngine.form.card.slots': 'Slots',
  'pages.bundlingEngine.form.card.split': 'Split and payout',
  'pages.bundlingEngine.type.exact.hint':
    'Pays exactly the amount the member entered. Shows in the Slots tab, Offers tab and Create your bundle.',
  'pages.bundlingEngine.type.higher.hint':
    'Raises the member’s amount by an upsell % to upsell a bigger circle. Offers tab only.',
  'pages.bundlingEngine.form.duration': 'Duration',
  'pages.bundlingEngine.form.durationOption': '{count} months',
  'pages.bundlingEngine.form.firstSlot': '1st payout',
  'pages.bundlingEngine.form.secondSlot': '2nd payout',
  'pages.bundlingEngine.form.chooseFirstFirst': 'Choose the 1st payout first.',
  'pages.bundlingEngine.form.slot.reasonLast':
    'The last slot has no later slot to pair with.',
  'pages.bundlingEngine.form.slot.reasonBefore':
    'Comes before or with the 1st payout ({first}).',
  'pages.bundlingEngine.form.slot.reasonLive':
    'Already a live rule of this type with the {first} slot. Deactivate that rule first.',
  'pages.bundlingEngine.form.split': 'Split, 1st / 2nd',
  'pages.bundlingEngine.form.firstSplit': '1st payout share',
  'pages.bundlingEngine.form.secondSplit': '2nd payout share',
  'pages.bundlingEngine.form.maxPayout': 'Max payout',
  'pages.bundlingEngine.form.maxPayout.hint':
    'Between {min} and {max}, in steps of {step}.',
  'pages.bundlingEngine.form.monthlyTarget': 'Monthly target',
  'pages.bundlingEngine.form.promoCode': 'Promo code (optional)',
  'pages.bundlingEngine.form.promoCode.placeholder': 'e.g. BUNDLE10',
  'pages.bundlingEngine.form.error.firstRequired':
    'Choose the slot the member gets first.',
  'pages.bundlingEngine.form.error.firstLast':
    'The last slot has no later slot to pair with. Choose an earlier 1st payout.',
  'pages.bundlingEngine.form.error.secondRequired':
    'Choose the 2nd payout slot.',
  'pages.bundlingEngine.form.error.secondAfterFirst':
    'Pick a slot after the {first}; the 2nd payout always comes later.',
  'pages.bundlingEngine.form.error.duplicate':
    '{first} with {second} is already a live rule of this type in {duration} months. Deactivate that rule first, or pick another slot.',
  'pages.bundlingEngine.form.error.split': 'Enter a whole number from 1 to 99.',
  'pages.bundlingEngine.form.error.maxPayout':
    'Enter at least {min}, in steps of {step}.',
  'pages.bundlingEngine.form.error.target':
    'Enter a monthly target above 0, in steps of {step}.',
  'pages.bundlingEngine.form.needAttention':
    '{count, plural, one {# field needs attention} other {# fields need attention}}',
  'pages.bundlingEngine.form.save': 'Create rule',
  'pages.bundlingEngine.form.cancel': 'Cancel',
  'pages.bundlingEngine.form.confirm.title': 'Create this rule?',
  'pages.bundlingEngine.form.confirm.note':
    'It goes live at the lowest priority and can’t be edited. To change it, deactivate it and create a new rule.',
  'pages.bundlingEngine.form.confirm.ok': 'Create rule',
  'pages.bundlingEngine.form.created': 'Bundle rule created.',
  'pages.bundlingEngine.form.createError': 'Failed to create the bundle rule.',
  'pages.bundlingEngine.preview.title': 'Preview',
  'pages.bundlingEngine.preview.hint':
    'Enter an example request amount to see how it is split across the two slots.',
  'pages.bundlingEngine.preview.amountLabel': 'Example request amount',
  'pages.bundlingEngine.preview.notReady':
    'Choose both slots and a valid split to see how a request is divided.',
  'pages.bundlingEngine.preview.invalidAmount':
    'Enter a multiple of {step}, at least {min}.',
  'pages.bundlingEngine.preview.result':
    '{amount} becomes {first} in the {firstSlot} slot ({firstMonth}) + {second} in the {secondSlot} ({secondMonth}).',
  'pages.bundlingEngine.preview.rounding':
    'An exact {firstSplit}% / {secondSplit}% split is {exactFirst} + {exactSecond}. The 1st is rounded down to {first} and the 2nd up to {second}, so the total stays {total}.',
  'pages.bundlingEngine.form.card.target': 'Target and promo',
  'pages.bundlingEngine.form.split.hint': 'The two always add up to 100%.',
  'pages.bundlingEngine.form.monthlyTarget.hint':
    'Total payout value to sell each month, in steps of EGP 3,000. Once reached, the rule is skipped until the 1st.',
  'pages.bundlingEngine.form.promoCode.hint':
    'Applied automatically to the bundle. Checked when you create the rule.',
  'pages.bundlingEngine.preview.exampleRequest': 'Example request',
  'pages.bundlingEngine.preview.liveTitle': 'Live as soon as you create it',
  'pages.bundlingEngine.preview.liveBody':
    'Members can be offered it from their next search.',
  'pages.bundlingEngine.form.error.maxPayoutLimit':
    'The max payout can’t be above {max} for this duration.',
  'pages.bundlingEngine.form.dataLoadError':
    'Failed to load the form data (types, durations and live slot pairs). Reload the page to try again.',
  'pages.bundlingEngine.form.error.splitUpsell':
    'Enter whole numbers from 1 to 100 that add up to more than 100%.',
  'pages.bundlingEngine.form.split.hintUpsell':
    'Together {total}% of the request, so the amount is raised by {upsell}%.',
  'pages.bundlingEngine.preview.needMaxPayout':
    'Enter the max payout to preview this rule.',
  'pages.bundlingEngine.preview.noRoom':
    'The max payout of {max} leaves no room to raise {amount}, so this rule would be skipped.',
  'pages.bundlingEngine.preview.raised':
    'The request is offered {total} in the Offers tab, {more} more ({upsell}% upsell, rounded up to EGP 3,000).',
  'pages.bundlingEngine.preview.raisedCapped':
    'The request is offered {total} in the Offers tab, {more} more, capped at the max payout.',
};
